import React from "react";
import {
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
  FaThumbsUp,
} from "react-icons/fa";
import "./styles/AdLike.css";
import { connect } from "react-redux";
import * as actions_ad from "../redux/actions/adActions";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import { I18n } from "react-redux-i18n";

class AdLike extends React.Component {

  state = {
    like: this.props.ad && this.props.ad.Like.Status,
    count_up: this.props.ad && this.props.ad.Like.Up,
    count_down: this.props.ad && this.props.ad.Like.Down,
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.ad !== this.props.ad &&
      this.props.ad &&
      this.props.ad.Like
    ) {
      this.setState({
        like: this.props.ad.Like.Status,
        count_up: this.props.ad.Like.Up,
        count_down: this.props.ad.Like.Down,
      });
    }
  }

  handleLike = async () => {
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }
    if (this.state.like === 1) {
      this.setState({
        like: null,
        count_up: this.state.count_up - 1,
      });
      await this.props
        .RemoveLike(this.props.token,
          {
            goder_id: this.props.ad.Id,
            id: this.props.user_id,
          })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } else {
      if (this.state.like === 0) {
        this.setState({ count_down: this.state.count_down - 1 });
      }
      this.setState({
        like: 1,
        count_up: this.state.count_up + 1,
      });
      await this.props
        .UpdateLike(this.props.token,
          {
            goder_id: this.props.ad.Id,
            status: "1",
            id: this.props.user_id,
          })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    }
  };

  handleUnlike = async () => {
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }
    if (this.state.like === 0) {
      this.setState({ like: null, count_down: this.state.count_down - 1 });
      await this.props
        .RemoveLike(this.props.token, {
          goder_id: this.props.ad.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } else {
      if (this.state.like === 1) {
        this.setState({ count_up: this.state.count_up - 1 });
      }
      this.setState({ like: 0, count_down: this.state.count_down + 1 });
      await this.props
        .UpdateLike(
          this.props.token,
          {
            goder_id: this.props.ad.Id,
            status: "'0'",
            id: this.props.user_id,
          }
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    }
  };

  render() {
    const { like, count_up, count_down } = this.state;

    return (
      <div className="container-goder-like">
        <div className="goder-like-bar" role="group" aria-label="Ad reactions">
          <button
            type="button"
            className={`goder-like-btn goder-like-btn--up${like === 1 ? " is-active" : ""}`}
            onClick={this.handleLike}
            aria-pressed={like === 1}
            title={I18n.t("ad_like")}
            aria-label={I18n.t("ad_like")}
          >
            <span className="goder-like-icon" aria-hidden="true">
              {like === 1 ? <FaThumbsUp /> : <FaRegThumbsUp />}
            </span>
            <span className="goder-like-count">{count_up}</span>
          </button>
          <span className="goder-like-divider" aria-hidden="true" />
          <button
            type="button"
            className={`goder-like-btn goder-like-btn--down${like === 0 ? " is-active" : ""}`}
            onClick={this.handleUnlike}
            aria-pressed={like === 0}
            title={I18n.t("ad_dislike")}
            aria-label={I18n.t("ad_dislike")}
          >
            <span className="goder-like-icon" aria-hidden="true">
              {like === 0 ? <FaThumbsDown /> : <FaRegThumbsDown />}
            </span>
            <span className="goder-like-count">{count_down}</span>
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    token: reducer.session.auth.access_token,
    user_id: reducer.session.auth.id,
    user: reducer.session.auth,
    ad: reducer.ad.item,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateLike: (token, params) =>
    dispatch(actions_ad.updateLike({ token, params })),
  RemoveLike: (token, params) =>
    dispatch(actions_ad.removeLike({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdLike);
